import { createPortal } from "react-dom";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

interface InsufficientCreditsDialogProps {
    onClose: () => void;
}

export const InsufficientCreditsDialog = ({ onClose }: InsufficientCreditsDialogProps) => {
    // Masterplan Paket 3: Credits sind fuer Nutzer unsichtbar - der Dialog spricht nur vom
    // Kontingent, ohne Zahlen. Ausloeser bleibt unveraendert der serverseitige insufficient_balance.
    const { t } = useTranslation("common");
    return createPortal(
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 999999 }}
            onClick={onClose}
        >
            <div
                className="sengi-dialog p-4 text-body"
                style={{ maxWidth: 420 }}
                onClick={e => e.stopPropagation()}
            >
                <h5>{t("quota.title")}</h5>
                <p className="text-secondary mb-4">
                    {t("quota.body")}
                </p>
                <div className="d-flex gap-2 justify-content-end">
                    <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                        {t("actions.cancel")}
                    </button>
                    <Link to="/billing" className="btn btn-primary" onClick={onClose}>
                        {t("quota.toBilling")}
                    </Link>
                </div>
            </div>
        </div>,
        document.body
    );
};
